import React, { useState, useEffect } from "react";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { addAnswer } from "../../redux/reducers/AnswerReducer";
import { addAnswer2 } from "../../redux/reducers/AnswerReducer2";
import { addRound } from "../../redux/reducers/RoundReducer";
import { updateMode } from "../../redux/reducers/ModeReducer";
import { setAllUserScore } from "../../redux/reducers/ScoreReducer";
import { authenticateUser } from "../../redux/reducers/UserReducer";

import ProgressBar from "./ProgressBar";
import ContentContainer from "../../components/ContentContainerComp/ContentContainer";
import ContentBox from "../../components/PraticeComp/ContentComp/ContentBox";
import ScorePanel from "../../components/PraticeComp/ScorePanel/ScorePanel";

import { getAllScore, SubmitScore2 } from "../../api/ScoreApi";
import { setCompleteWeek } from "../../api/FakeApi";
import { SubmitLessonLog } from "../../api/LogApi";
import { getLessonContent, getQuiz } from "../../api/contentApi";

import s from "./style.module.css";

const PracticeContainer = () => {
  const userEmail = localStorage.getItem("authUser");
  const ansRedux = useSelector((state) => state.Answer2);
  const Round = useSelector((state) => state.Round);
  const PracticeData = useSelector((state) => state.PracticeData);
  const UserInfo = useSelector((state) => state.UserInfo);
  const dispatch = useDispatch();
  const [contentID, setContentID] = useState(1);
  const [disableNext, setDisableNext] = useState(0);
  const [disableฺฺBack, setDisableฺฺBack] = useState(0);
  const [ansData, setAnsData] = useState([]);
  const [checkedAnswer, setCheckedAnswer] = useState([]);
  const [checkedContent, setCheckedContent] = useState([]);
  const [repeat, setRepeat] = useState(true);
  const [ansTempArray, setAnsTempArray] = useState([]);
  const [lessonContent, setLessonContent] = useState([]);
  const [quizContent, setQuizContent] = useState([]);
  const [endTime, setEndTime] = useState(moment().format("DDMMYY HH:mm:ss a"));
  const [endTime2, setEndTime2] = useState(
    moment().format("DDMMYY HH:mm:ss a")
  );

  const MergeContent = [...lessonContent, ...quizContent];
  const ContentArray = () => {
    const AllContent = MergeContent.map((item, idx) => {
      return {
        id: idx + 1,
        ...item,
      };
    });
    return AllContent;
  };

  const handleCheckContentInQuiz = (qId) => {
    // const quizObj = quizContent.filter((item) => item.question_id === qId + 1);
    const quizIndex = ContentArray().findIndex(
      (item) => item.question_id === qId
    );
    const test = ContentArray();
    if (qId === 100) {
      setDisableNext(1);
    } else {
      if (test[quizIndex + 1] !== undefined) {
        if (!!test[quizIndex + 1].label1 || !!test[quizIndex + 1].videoLink) {
          setDisableNext(0);
        }
      } else {
        setDisableNext(1);
      }
    }
  };

  const handleDisableNextButton = (e) => {
    if (!!ContentArray()[e].question_id) {
      setDisableNext(1);
      setDisableฺฺBack(1);
    } else if (!!ContentArray()[e].content_id) {
      setDisableNext(0);
      setDisableฺฺBack(0);
    }
  };
  const handleNextContent = () => {
    if (contentID === ContentArray().length) {
      setContentID(ContentArray().length + 1);
    } else if (contentID > ContentArray().length) {
      setContentID(1);
    } else {
      setContentID(contentID + 1);
    }
    handleDisableNextButton(contentID);
  };
  const handleBackContent = () => {
    if (contentID === 1) {
      setContentID(1);
    } else {
      setContentID(contentID - 1);
    }
    // contentID มีไว้บอกเลขหน้าที่ -2 ก็เพราะตอนกด back มันดันไม่ได้ลบเลย 1 หน้า
    //สมมุติอยู่หน้า 12 อยากกลับไปหน้าก่อหน้านั้นแทนที่จะไปหน้า 11 กลายเป็นเลขหน้าบอกอยู่หน้า 13 ทั้งที่ render หน้า 11 อยู่
    handleDisableNextButton(contentID - 2);
  };

  const handleCheckRedux = (answerObj) => {
    const EditIndex = ansTempArray.findIndex(
      (item) => item.question_id === answerObj.question_id
    );
    if (EditIndex !== -1) {
      answerObj[EditIndex] = {
        question_id: answerObj.question_id,
        answer_id: answerObj.answer_id,
        timeStart: answerObj.timeStart,
        timeEnd: answerObj.timeEnd,
      };
      return answerObj;
    }
    setAnsTempArray([...ansTempArray, answerObj]);
    dispatch(addAnswer2(answerObj));
  };

  const handleGetAnswer = (questionId, answer, quizType, answer2Type5) => {
    const currentDate = moment().format("DDMMYY HH:mm:ss a");
    const ansObj = {
      question_id: questionId,
      answer_id: answer,
      timeStart: `${endTime.toString()}`,
      timeEnd: `${currentDate.toString()}`,
    };
    let ansObj2 = {};
    ///////////////////////////////// start of new code /////////////////////////////////
    const quizHint = quizContent.find(
      (item) => item.question_id === questionId
    ).hint;
    // quiz type 3
    if (quizType === 3) {
      const answerType3Array = answer.map((item) => item.id);
      if (
        quizHint.every((item) => answerType3Array.includes(item)) &&
        answerType3Array.every((item) => quizHint.includes(item))
      ) {
        ansObj2 = { ...ansObj, answer_id: true };
        handleCheckRedux(ansObj2);
        setContentID(contentID + 1);
        setRepeat(true);
        handleCheckContentInQuiz(questionId);
        setCheckedAnswer([...checkedAnswer, ansObj2]);
      } else {
        ansObj2 = { ...ansObj, answer_id: false };
        handleCheckRedux(ansObj2);
        setRepeat(false);
        handleCheckContentInQuiz(100);
      }
    } else if (quizType === 4) {
      const answerType4Array = answer.map((item) => item.id);

      const check =
        Array.isArray(answerType4Array) &&
        Array.isArray(quizHint) &&
        answerType4Array.length === quizHint.length &&
        answerType4Array.every((val, index) => val === quizHint[index]);

      if (check) {
        ansObj2 = { ...ansObj, answer_id: true };
        handleCheckRedux(ansObj2);
        setContentID(contentID + 1);
        setRepeat(true);
        handleCheckContentInQuiz(questionId);
        setCheckedAnswer([...checkedAnswer, ansObj2]);
      } else {
        ansObj2 = { ...ansObj, answer_id: false };
        handleCheckRedux(ansObj2);
        setRepeat(false);
        handleCheckContentInQuiz(100);
      }
    } else if (quizType === 5) {
      if (quizHint === answer) {
        ansObj2 = { ...ansObj, answer_id: true };
        handleCheckRedux(ansObj2);
        setContentID(contentID + 1);
        // setRepeat(true);
        handleCheckContentInQuiz(questionId);
        setCheckedAnswer([...checkedAnswer, ansObj2]);
      } else {
        ansObj2 = { ...ansObj, answer_id: false };
        handleCheckRedux(ansObj2);
        setContentID(contentID + 1);
        // setRepeat(true);
        handleCheckContentInQuiz(questionId);
        setCheckedAnswer([...checkedAnswer, ansObj2]);
      }
    } else {
      // quiz type 1-2
      if (quizHint === answer) {
        ansObj2 = { ...ansObj, answer_id: true };
        handleCheckRedux(ansObj2);
        setContentID(contentID + 1);
        setRepeat(true);
        handleCheckContentInQuiz(questionId);
        setCheckedAnswer([...checkedAnswer, ansObj2]);
      } else {
        ansObj2 = { ...ansObj, answer_id: false };
        handleCheckRedux(ansObj2);
        setRepeat(false);
        handleCheckContentInQuiz(100);
      }
    }

    ///////////////////////////////// end of new code /////////////////////////////////
    const index = ansData.findIndex((el) => el.question_id === questionId);
    if (index === -1) {
      setAnsData([...ansData, ansObj]);
      setEndTime(currentDate);
    } else {
      const duplicateAns = ansData;
      duplicateAns.splice(index, 1);
      setAnsData([...duplicateAns, ansObj]);
      setEndTime(currentDate);
    }
    dispatch(addAnswer(ansObj));
    // setContentID(contentID + 1);
  };
  const handleGetLog = (id) => {
    const currentDate = moment().format("DDMMYY HH:mm:ss a");
    const contentObj = {
      content_id: id,
      timeStart: `${endTime2.toString()}`,
      timeEnd: `${currentDate.toString()}`,
    };
    const EditIndex = checkedContent.findIndex(
      (item) => item.content_id === id
    );
    if (EditIndex === -1) {
      setCheckedContent([...checkedContent, contentObj]);
      setEndTime2(currentDate);
    }
  };

  const LessonPercentage = () => {
    const allLessonPage = ContentArray().filter((item) => !!item.content_id);
    const currentLessonPage =
      contentID > allLessonPage.length ? allLessonPage.length : contentID;
    const result = (currentLessonPage / allLessonPage.length) * 60;
    return result;
  };

  const QuizPercentage = () => {
    const allQuizPage = ContentArray().filter((item) => !!item.quizType);
    let correctAns = ansRedux.filter((item) => item.answer_id === true);
    const calculateCorrect = (correctAns.length / allQuizPage.length) * 40;
    return calculateCorrect;
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSubmitAns = () => {
    // const lesson = `lesson${2}`;
    const allScore = LessonPercentage() + QuizPercentage();
    const data = {
      week: PracticeData.week,
      allAnswer: ansRedux,
      score: allScore,
      round: Round,
    };
    SubmitScore2(data, userEmail, Round, PracticeData.grade, PracticeData.week);
  };
  const handlePassWeek = () => {
    const allScore = QuizPercentage();
    const test = UserInfo.completeWeek.filter(
      (item) => item.grade !== PracticeData.grade
    );

    const completeWeekData = {
      ...UserInfo,
      completeWeek: [
        ...test,
        { grade: PracticeData.grade, week: PracticeData.week + 1 },
      ],
    };
    if (allScore >= 20) {
      setCompleteWeek(completeWeekData, userEmail);
      dispatch(authenticateUser(completeWeekData));
    }
  };
  useEffect(() => {
    handleGetLog(contentID);
    if (contentID !== 1 && checkedContent.length === lessonContent.length) {
      SubmitLessonLog(
        { data: checkedContent },
        userEmail,
        Round,
        PracticeData.grade,
        PracticeData.week
      );
      // setCheckedAnswer([]);
    }
  }, [contentID]);

  useEffect(() => {
    getLessonContent(PracticeData.grade, PracticeData.week).then((res) => {
      setLessonContent(res);
    });
    getQuiz(PracticeData.grade, PracticeData.week).then((res) => {
      setQuizContent(res);
    });
  }, [PracticeData.grade, PracticeData.week]);

  useEffect(() => {
    const QuizLength = quizContent.filter(
      (item) => !!item.question_label
    ).length;

    if (
      checkedAnswer.length === QuizLength &&
      QuizLength !== 0 &&
      checkedAnswer.length !== 0
    ) {
      handlePassWeek();
      handleSubmitAns();
      dispatch(addRound(1));
      setCheckedAnswer([]);
    }
  }, [checkedAnswer]);

  useEffect(() => {
    getAllScore(PracticeData.grade).then((res) => {
      const allScore = LessonPercentage() + QuizPercentage();
      const result = {
        otherScore: res,
        userScore: allScore,
        name: userEmail,
      };

      dispatch(setAllUserScore(result));
    });
  }, [QuizPercentage(), LessonPercentage()]);

  if (lessonContent.length <= 0 || quizContent.length <= 0) {
    return <React.Fragment />;
  }

  return (
    <React.Fragment>
      {contentID !== ContentArray().length + 1 && (
        <ProgressBar
          LessonPercentage={LessonPercentage()}
          QuizPercentage={QuizPercentage()}
        />
      )}

      {contentID === ContentArray().length + 1 ? (
        <ContentContainer
          typeHeader
          textHeader="ผ่านด่าน"
          textHeaderColor="#ffffff"
          onCenter
          disableBack={1}
          onPressBack={handleBackContent}
          onPressNext={() => dispatch(updateMode({ mode: 1, step: 4 }))}
        >
          <div className={s.ContentWrapper}>
            <React.Fragment>
              <ScorePanel
                LessonPercentage={LessonPercentage()}
                QuizPercentage={QuizPercentage()}
              />
            </React.Fragment>
          </div>
        </ContentContainer>
      ) : (
        <ContentContainer
          typeHeader={contentID === 1 ? 1 : null}
          textHeader={contentID === 1 ? `ด่านที่ ${PracticeData.week}` : null}
          onLesson
          disableNext={disableNext}
          disableBack={contentID === 1 || disableฺฺBack ? 1 : 0}
          onPressBack={handleBackContent}
          onPressNext={handleNextContent}
          contentID={contentID}
          audioLink={ContentArray()[contentID - 1].audioLink}
          videoLink={ContentArray()[contentID - 1].videoLink}
        >
          <div className={s.ContentWrapper}>
            <ContentBox
              Repeat={repeat}
              handleGetAnswer={handleGetAnswer}
              ContentArray={ContentArray()}
              contentID={contentID}
              handleRepeat={setRepeat}
            />
          </div>
        </ContentContainer>
      )}
    </React.Fragment>
  );
};

export default PracticeContainer;
